var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.541,
    height: 13.541,
    viewBox: "0 0 13.541 13.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M16.318,15.25,13.761,12.7a5.956,5.956,0,0,0,1.271-3.685,6.016,6.016,0,1,0-6.016,6.016A5.956,5.956,0,0,0,12.7,13.761l2.549,2.557a.755.755,0,1,0,1.068-1.068ZM4.5,9.016a4.512,4.512,0,1,1,4.512,4.512A4.512,4.512,0,0,1,4.5,9.016Z",
    transform: "translate(-3 -3)",
    fill: "#777"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraySearch);
export default __webpack_public_path__ + "static/media/gray-search.7c952b6cc8e6628fcabf1da7c1d171a9.svg";
export { ForwardRef as ReactComponent };